import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BreadcrumpComponent } from "../components/subcomponents/BreadcrumpCompont";
import bigCover from "../assets/images/big-cover.jpg";
import { apiGet } from "../utils/api";
import { routes } from "../utils/utils.routes";
import { PageSkeleton } from "../components/PageSkeleton";
import { useLanguage } from "../contexts/LanguageContext";
import { pickLocalized, stripHtml } from "../utils/locale";
import { Colors } from "../utils/utils.colors";

export const Faculties = ({ showBreaCramp = true }: { showBreaCramp?: boolean }) => {
  const { lang, t } = useLanguage();
  const [faculties, setFaculties] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiGet("/faculties").then((d) => setFaculties(d.rows)).finally(() => setLoading(false));
  }, []);

  return (
    <>
      {showBreaCramp && (
        <BreadcrumpComponent
          imageCover={bigCover}
          eyebrow="Académique"
          title={t.faculty.title}
          subtitle={t.faculty.subtitle}
        />
      )}
      <div className={`page-content ${showBreaCramp ? "padding-x" : ""} is-layout-constrained faculty-page py-0 ${showBreaCramp ? "pb-5" : ""}`}>
        {loading ? (
          <PageSkeleton />
        ) : (
          <div data-testid="faculties-grid" className="faculty-grid">
            {faculties.map((fac) => {

              const name = pickLocalized(fac, "name", lang);
              const domaine = pickLocalized(fac, "domaine", lang);
              const desc = stripHtml(pickLocalized(fac, "description", lang));
              const dean = pickLocalized(fac, "dean", lang);

              return (
                <Link
                  key={fac.id}
                  to={`${routes.FACULTIES}/${fac.slug}`}
                  data-testid={`faculty-card-${fac.slug}`}
                  className="faculty-card"
                >
                  {fac.coverImage && (
                    <div className="faculty-card__cover" style={{ backgroundImage: `url(${fac.coverImage})` }} />
                  )}
                  <div className="faculty-card__body">
                    <div className="faculty-card__tag" style={{ color: Colors.redColor }}>{domaine}</div>
                    <h3 className="faculty-card__title">{name}</h3>
                    <p className="faculty-card__excerpt">{(desc || "").slice(0, 160)}{desc.length > 160 ? "…" : ""}</p>
                    <div className="faculty-card__meta">
                      <div><b>{t.faculty.dean}:</b> {dean || "—"}</div>
                      <div style={{ marginTop: 4 }}>
                        <b>{fac.filieres?.length || 0}</b> {t.faculty.programsCount}
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};
